// extracted by mini-css-extract-plugin
export var $animation_name = "PageCarousel-module--$animation_name--79687";
export var PageCarousel = "PageCarousel-module--PageCarousel--666c1";